<template>
    <!-- form fields for the company section -->
    <div>
        <!-- THE COMPANY : NAME -->
        <el-form-item prop="name" :label="$t.__('common.labels.society_name')">
            <el-input
                class="form-fields-company-shorten--name"
                name="company"
                autocomplete="on"
                @input="searchCompanyByName"
                v-model="name"
                :data-bot="getDatabot('name', dataBotsContext, null, 'company-popup')"
            ></el-input>
        </el-form-item>
        <div v-if="companiesList.length > 0" class="mt-0 mb-3">
            <el-alert
                :closable="false"
                class="mb-2 mt-2 alert alert-warning"
                :title="$t.__('common.labels.company_already_exist_in_your_directory')"
                type="warning"
            >
            </el-alert>
            <ul>
                <form-fields-companies-list
                    v-for="(company, index) in companiesList"
                    class="form-fields-companies-list br b-1-gray-05 mb-2 gray-0-bkg px-3"
                    style="height: 66px"
                    :key="index"
                    :company="company"
                    :overview="true"
                />
            </ul>
        </div>

        <!-- THE COMPANY : TYPE -->
        <el-form-item prop="type" :label="$t.__('common.labels.type')">
            <el-select v-model="type" class="wp-10" :disabled="typeDisabled">
                <el-option
                    :data-bot="getDatabot('type', dataBotsContext, null, 'company-popup')"
                    v-for="option in typeList"
                    :key="option.label"
                    :value="option"
                    :label="tagsHuman[option].label"
                />
            </el-select>
        </el-form-item>
    </div>
</template>

<script>
import TagHumansConfig from 'Config/authenticated/TagHumans';
import FormFieldsCompaniesList from 'vcomponents/thirds/thirdscomponents/FormFieldsCompaniesList.vue';
import DataBotsFormsMixins from 'mixins/DataBotsFormsMixins';

export default {
    mixins: [DataBotsFormsMixins],
    props: {
        currentStore: {
            type: String,
            required: true,
        },
        dataBotsContext: {
            type: String,
            required: false,
            default: '',
        },
    },
    components: {
        FormFieldsCompaniesList,
    },
    created() {
        if (this.currentStore && this.$store.state[this.currentStore]) {
            this.$store.dispatch(`${this.currentStore}/fetchThirdMetadata`, 'companies');
        }
    },
    computed: {
        name: {
            get() {
                return this.$store.getters[`${this.currentStore}/getName`];
            },
            set(value) {
                this.$store.commit(`${this.currentStore}/setName`, value);
            },
        },
        typeList() {
            return this.$store.getters[`${this.currentStore}/getTypes`];
        },
        type: {
            get() {
                return this.$store.getters[`${this.currentStore}/getType`];
            },
            set(value) {
                this.$store.commit(`${this.currentStore}/setType`, value);
                this.$emit('change-type', value);
            },
        },
        tagsHuman() {
            return TagHumansConfig;
        },
        companiesList() {
            let list = this.$store.getters[`${this.currentStore}/getSuggestionCompaniesList`];
            return list && list.length > 0 ? list : [];
        },
        typeDisabled() {
            return !_.isNil(this.$store.getters[`${this.currentStore}/getId`]);
        },
    },
    methods: {
        searchCompanyByName: _.debounce(function (name) {
            if (!_.isNil(this.$store.state[this.currentStore])) {
                this.$store
                    .dispatch(`${this.currentStore}/fetchCompaniesList`, {
                        search: name,
                        siretAllowed: false,
                    })
                    .then((res) => {
                        this.$store.commit(`${this.currentStore}/setSuggestionCompaniesList`, res);
                    });
            }
        }, 400),
    },
};
</script>
